import {Api} from './config/request';

export const VerifyLogin = () => {
    return Api.postRequest('verifyLogin');
};

export const RegisterUser = (payload) => {
    return Api.postRequest('registerNewUser?type=ii', payload);
};

export const verifyRegistration = (p) =>
    Api.postRequest(`addRegistration?regCode=${p.regCode}`, null);

export const getSalesRepresetativeList = () => {
    return Api.getListRequest('getMarketingTeam');
};

const UserApi = {
    VerifyLogin,
    RegisterUser,
    verifyRegistration,
    getSalesRepresetativeList,
};

export default UserApi;
